import { render, staticRenderFns } from "./UDatePicker.vue?vue&type=template&id=31d66448"
import script from "./UDatePicker.vue?vue&type=script&lang=js"
export * from "./UDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports